$.fn.Guarantees = function(_e)
{
	var _g = this;
	_g.e = _e;
	_g.form = _g.find("form");
	_g.model = undefined;	// defined later
	_g.interface = {
		guarantees_field : undefined,
		banque_modal : undefined,
		banque_details_btn: _g.find("button.banque-modal"),
		next_tab_btn : _g.find("button[data-action='next-tab']"),
		calculator : {
			cachet_jour : _g.find('input[name=cachet_jour]'),
			cachet: _g.find('input[name=cachet]'),
			taux_horaire: _g.find('input[name=taux_horaire]'),
			hre_supp: _g.find('input[name=hre_supp]'),
			droits_percent: _g.find('input[name=droits]'),
			droits: _g.find('input[name=droits]'),
			total: _g.find('input[name=total]'),
		}
	};
	_g.baseFee = 0.00;

	_g.calc = {
		update_item: function()
		{
			// send details to contract model
			_g.model = _g.e.interface.tabs.contract.model;
			_g.model.item["fonction"] = _g.get_value("fonction");
			_g.model.item["jours_tournage"] = _g.get_value("jours_tournage");
			_g.model.item["emissions_episodes"] = _g.get_value("emissions_episodes");
			_g.model.item["banque"] = _g.get_value("banque");
			_g.model.item["banque_details"] = _g.get_value("banque_details");
			_g.model.item["garanties"] = _g.get_value("garanties");
			_g.model.item["cachet"] = _g.get_value("cachet");
			_g.model.item["cachet_total"] = _g.get_value("total");
			_g.model.item["droits_percent"] = _g.get_value("droits_percent");
			_g.model.item["droits_total"] = _g.get_value("droits");
			_g.model.save();
		},
		option: function(path)
		{
			var value = 0;
			if (path.length == 1){
				value = asFloat(_g.e.getConventionData().options[path[0]]);
			} else if (path.length == 2){
				value = asFloat(_g.e.getConventionData().options[path[0]][path[1]]);
			}
			if (isNaN(value)){
				value = 0;
			}
			return value;
		},
		base_fee: function()
		{
			// calculate base fee
			var base_fee = 0,
			cachet = _g.get_value('cachet'),
			droits_percent = _g.get_value('droits_percent'),
			factor = _g.calc.highest_number(),
			banque = _g.get_value('banque');

			// no fee returned
			if (!_g.form.data("loaded")){
				return 0;
			}

			// set hourly rate
			var taux_horaire = cachet / 8;
			_g.interface.calculator.taux_horaire.val(taux_horaire.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));

			// set supp amount
			var taux_horaire_supp = taux_horaire * 1.5;
			_g.interface.calculator.hre_supp.val(taux_horaire_supp.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));

			// get guarantees fees
			var guarantees_totals = _g.calc.guarantees_fees();

			// set droits amount
			var droits_cachet = (cachet * factor) * droits_percent / 100;
			var droits = droits_cachet + (guarantees_totals.rights * droits_percent / 100);
			_g.interface.calculator.droits.val(droits.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));

			// set total
			var total = parseFloat((cachet * factor) + droits + (guarantees_totals.total) + banque);
			_g.interface.calculator.total.val(total.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));

			// set daily fee
			var cachet_jour = factor ? total / factor : 0;
			if (isNaN(cachet_jour)) cachet_jour = 0;
			_g.interface.calculator.cachet_jour.val(cachet_jour.toLocaleString('fr-CA', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2
			}));

			return total;
		},
		highest_number: function()
		{
			// calculate highest number
			var jours_tournage = _g.get_value('jours_tournage'),
			emissions_episodes = _g.get_value('emissions_episodes'),
			highest_number = Math.max(jours_tournage, emissions_episodes);
			if (highest_number < 0) highest_number = 0;
			return highest_number;
		},
		guarantees_fees: function()
		{
			// no field?
			if (_g.interface.guarantees_field == undefined){
				return 0;
			}

			// calculate guarantees fee
			var guarantees_fees = { rights: 0, total: 0 },
			taux_horaire = _g.get_value('taux_horaire'),
			droits_percent = _g.get_value('droits_percent');

			// loop through guarantees
			var guarantees = JSON.parse(_g.interface.guarantees_field.val());
			guarantees.forEach(function(guarantee, index){
				guarantee_totals = _g.calc.guarantee_fee(guarantee);
				guarantees_fees.total += guarantee_totals.total;
				_g.interface.guarantees_field.rows[index].find('input[name="guarantee_total"]').val(guarantee_totals.total);
				if (guarantee_totals.rights){
					guarantees_fees.rights += guarantee_totals.total;
					_g.interface.guarantees_field.rows[index].find('input[name="guarantee_droits"]').val(guarantee_totals.total * droits_percent / 100);
				}
				_g.interface.guarantees_field.rows[index].find('input[name="guarantee_number"]').val(guarantee_totals.display ? guarantee_totals.display : '');
			});
			return guarantees_fees;
		},
		guarantee_fee: function(guarantee, force_amount)
		{
			// force amount?
			if (force_amount == undefined){
				force_amount = false;
			}

			// get item value
			var item_value = asFloat(guarantee.guarantee_number);
			if (isNaN(item_value) || item_value < 0) item_value = 0;
			var totals = { total: 0, rights: 0, display: item_value };

			// edit item value
			if (item_value && guarantee.guarantee_item && guarantee.guarantee_item != "NONE"){
				var guarantee_config = _g.e.getConventionData().guarantees[guarantee.guarantee_item],
				calc_config = guarantee_config.calc;

				// set field values
				switch (calc_config[0]) {
					case "%": {
						var raw_value = parseInt(item_value, 10);
						if (!raw_value) raw_value = 0;
						totals.display = raw_value + "%";
						break;
					}
					case "$": {
						var raw_value = asFloat(item_value, 10);
						if (!raw_value) raw_value = 0;
						raw_value = raw_value.toLocaleString('fr-CA', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						});
						totals.display = raw_value + " $";
						break;
					}
					case "int": {
						var raw_value = parseInt(item_value, 10);
						if (!raw_value) raw_value = 0;
						totals.display = raw_value;
						break;
					}
					case "float": {
						var raw_value = asFloat(item_value);
						if (!raw_value) raw_value = 0;
						raw_value = raw_value.toLocaleString('fr-CA', {
							minimumFractionDigits: 2,
							maximumFractionDigits: 2
						});
						totals.display = raw_value;
						break;
					}
				}

				// get action
				switch(calc_config[1]){
					case "fn": {
						var input_value = asFloat(item_value);
						totals.total = _g.calc.fn[calc_config[2]](input_value);
						break;
					}
					case "*": {
						var input_value = asFloat(item_value);
						if (isNaN(input_value) || input_value == 0){
							totals.total = 0;
						} else {
							if (isNaN(calc_config[2])){
								totals.total = input_value * _g.calc.fn.grid_value(calc_config[2]);
							} else {
								totals.total = input_value * calc_config[2];
							}
						}
						break;
					}
					case "=": {
						var input_value = asFloat(item_value);
						if (isNaN(input_value) || input_value == 0){
							totals.total = 0;
						} else if (!force_amount && calc_config[2] === 0){
							totals.total = 0;
						} else {
							totals.total = input_value;
						}
						break;
					}
					default: {
						// * with percentage factor
						if (calc_config[1].charAt(0) === "*"){
							var percent = asFloat(calc_config[1].substr(1)) / 100,
							input_value = asFloat(item_value);
							if (isNaN(input_value) || input_value == 0){
								totals.total = 0;
							} else {
								if (calc_config[2] === "c"){
									totals.total = input_value * _g.calc.values.cachet() * percent;
								} else if (calc_config[2] === "hc"){
									totals.total = input_value * _g.calc.values.taux_horaire() * percent;
								} else if (isNaN(calc_config[2])){
									totals.total = input_value * _g.calc.fn.grid_value(calc_config[2]) * percent;
								} else {
									totals.total = input_value * calc_config[2] * percent;
								}
							}
						}
					}
				}

				// rights if needed
				if (guarantee_config.droits){
					totals.rights = 1;
				}
			}
			return totals;
		},
		guarantee_fee_for: function(item_type) {
			// loop through guarantees
			var guarantees_total = 0,
			guarantees = JSON.parse(_g.interface.guarantees_field.val());
			guarantees.forEach(function(guarantee, index){
				if (guarantee.guarantee_item === item_type){
					var guarantee_total = _g.calc.guarantee_fee(guarantee);
					guarantees_total += guarantee_total.total;
				}
			});
			return guarantees_total;
		},
		guarantee_amount_for: function(item_type) {
			// loop through guarantees
			var guarantees_amount = 0,
			guarantees = JSON.parse(_g.interface.guarantees_field.val());
			guarantees.forEach(function(guarantee, index){
				if (guarantee.guarantee_item === item_type){
					var guarantee_total = _g.calc.guarantee_fee(guarantee, true);	// force amount
					guarantees_amount += guarantee_total.total;
				}
			});
			return guarantees_amount;
		},
		fn: {
			grid_value: function(input_value){
				var fonction = _g.get_value('fonction')
				if (fonction == 'NONE') {
					return 0;
				}
				var category = _g.e.getConventionData().roles[fonction].category;
				if (!category) {
					return 0;
				}
				return _g.calc.option(['cat_' + category, input_value]);
			},

			/* get divided contract value */
			jours_attente: function(input_value)
			{
				var j = _g.calc.fn.grid_value("j");
				var total = 0;
				if (input_value > 2) {
					total += (j * .25 * 2) + (j * .5 * (input_value - 2));
				} else {
					total += (j * .25 * input_value);
				}
				return total;
			},
		},
		values: {
			taux_horaire: function(){
				var value = asFloat(_g.get_value('taux_horaire'));
				if (isNaN(value) || !value) { value = 0; }
				return value;
			},
			cachet: function(){
				var value = asFloat(_g.get_value('cachet'));
				if (isNaN(value) || !value) { value = 0; }
				return value;
			},
			droits_percent: function(){
				var value = asFloat(_g.get_value('droits_percent'));
				if (isNaN(value) || !value) { value = 0; }
				return value / 100;
			}
		}
	};

	_g.changed = function(event)
	{
		// variables
		var field = $(event.target),
		key = undefined,
		value = undefined;

		// normal fields
		key = field.attr("name");
		value = field.val();

		// floats
		if (key == "cachet" || key == "banque"){
			value = asFloat(value);
			if (isNaN(value)){
				value = "0,00";
			} else {
				value = value.toLocaleString('fr-CA', {
					minimumFractionDigits: 2,
					maximumFractionDigits: 2
				});
			}
			field.val(value);
		} else if (key == "droits_percent") {
			value = asFloat(value);
			if (isNaN(value)){
				value = "0";
			} else {
				value = value.toLocaleString('fr-CA', {
					minimumFractionDigits: 0,
					maximumFractionDigits: 2
				});
			}
			field.val(value);
		}

		// ints
		if (key == "jours_tournage" || key == "emissions_episodes"){
			value = parseInt(value, 10);
			if (isNaN(value)){
				value = 0;
			}
			if (value < 0) value = 0;
			field.val(value);
		}

		// automatically update fee
		_g.updateFee();

		// element set
		_g.calc.update_item();
		_g.e.updateOptionsList();
	};

	_g.get_value = function(key)
	{
		// input fields
		var input = _g.find("input[name='" + key + "']"),
		select = _g.find("select[name='" + key + "']");

		// guarantees field
		if (key == "garanties"){
			return _g.interface.guarantees_field.val();
		}

		// fields not found
		if (!input.length && !select.length){
			return undefined;
		}

		// input field
		if (input.length){
			if (input.attr("type") == "checkbox" || input.attr("type") == "radio"){
				return _g.find("input[name='" + key + "']:checked").val();
			} else {
				var valueFloat = asFloat(input.val()),
				valueInteger = parseInt(input.val(), 10);
				if (!isNaN(valueInteger)){
					if (valueInteger != valueFloat){
						return valueFloat;
					}
					return valueInteger;
				}
				return input.val();
			}

			// select field
		} else if (select.length){
			return select.val();
		}
	};

	_g.updateFee = function()
	{
		_g.baseFee = _g.calc.base_fee();
		_g.e.updateInterface();
	};

	_g.getFee = function()
	{
		return _g.baseFee;
	};

	_g.getGuaranteeFee = function(item_type)
	{
		return _g.calc.guarantee_fee_for(item_type);
	};

	_g.getGuaranteeAmount = function(item_type)
	{
		return _g.calc.guarantee_amount_for(item_type);
	};

	_g.getConventionName = function()
	{
		return _g.e.find("select[name=config]").val();
	};

	_g.getOptionsList = function()
	{
		// return _g.model.getOptionsList();
	};

	_g.initialize = function()
	{
		// select with search
		// the tab can reload while closed: skip only the row template and already initialized selects
		_g.find(".select-search").not(".template select, .select2-hidden-accessible").each(function(){
			$(this).select2({
				language: "fr"
			});
		});

		// add first guarantee
		_g.find('.repeater-field').each(function(){
			_g.interface.guarantees_field = $(this).RepeaterField();
			if (!_g.interface.guarantees_field.rows.length){
				_g.interface.guarantees_field.add_row();
			}
			// focus sur la garantie de la nouvelle ligne
			_g.interface.guarantees_field.el.button.add.on("click", function(){
				var rows = _g.interface.guarantees_field.rows;
				rows[rows.length - 1].find(".select2-selection").first().focus();
			});
		});

		// event listeners
		_g.find('.slr-watched :input').on("change", _g.changed);
		_g.interface.guarantees_field.on("update", function(){
			_g.changed({target: _g.interface.guarantees_field});
		})
	};

	_g.openBanqueDetails = function() {
		if (_g.interface.banque_modal == undefined){
			_g.interface.banque_modal = _g.find('.banque-details-modal').Banque(_g);
		}
		_g.interface.banque_modal.modal('show');
		return false;
	};

	_g.getBanqueDetails = function() {
		return _g.find('input[name="banque_details"]').val().split(',');
	};

	_g.setBanqueDetails = function(value) {
		_g.find('input[name="banque_details"]').val(value).change();
	};

	return function()
	{
		// form
		if (_g.form.data("loaded") == true){
			_g.initialize();
			_g.updateFee();
		} else {
			_g.updateFee();
			_g.e.setInitialOptionsList();
		}
		_g.form.on("submit", function(){
			return false;
		});

		// next tab button
		_g.interface.next_tab_btn.on("click", function(){
			_g.e.reachTab(2);
			return false;
		});

		// banque details button
		_g.interface.banque_details_btn.on('click', _g.openBanqueDetails);

		// convention select, bound once per element since this tab reloads after creation
		_g.e.find("select[name=config]").off("change.guarantees").on("change.guarantees", function(){
			_g.e.set("config", $(this).val());
			if (_g.form.data("loaded") == true){
				_g.changed({target: _g.interface.guarantees_field});
			} else {
				_g.e.updateOptionsList();
			}
		});

		// return object
		return _g;
	}();
};
